import { removeInvalidOptions } from '../../field-viewer/shared-normalizers';
export const checkboxGroupViewer = {
    normalizeLoadedValue: removeInvalidOptions
};

//# sourceMappingURL=definition-viewer.js.map